// Карточка «Входящих» (032: contracts/api.md, «Маршруты», inbox.card; FR-001, FR-004, FR-005;
// ASG-HIST-03; plan.md, «Решения»). Справа от ленты — пункт с историей и действиями. Пункт
// отдаётся, только если протокол пользователю виден (фильтр видимости 031, canOpen): иначе —
// только событие; руководитель по строке «Ответ получен» пункт и историю не получает (поправка
// XII 2.7.0). Строка контролёру — ответ из письма, который не применился, или ответное письмо.
import { z } from '../kernel/zod.ts';
import { IdSchema, PersonRefSchema, TimestampSchema } from '../kernel/common.ts';
import { NotificationSchema } from '../kernel/notification.ts';
import { ControlItemSchema } from '../api/documents.ts';
import { WorkStateSchema } from '../minutes/item.ts';
import { LetterAnswerKindSchema, LetterAnswerOutcomeSchema } from './answer.ts';

/** Ответ со страницы ответа в карточке контролёра. test — письмо песочницы («проверка»). */
export const InboxAnswerSchema = z.object({
  id: IdSchema,
  kind: LetterAnswerKindSchema,
  note: z.string().optional(),
  dueRaw: z.string().optional(),
  reason: z.string().optional(),
  outcome: LetterAnswerOutcomeSchema,
  test: z.boolean(),
  person: PersonRefSchema,
  at: TimestampSchema,
  /** Ответ уже внёс контролёр. */
  enteredAt: TimestampSchema.optional(),
});
export type InboxAnswer = z.infer<typeof InboxAnswerSchema>;

/** Ответное письмо на письмо о пунктах: тема, текст, пункты письма. */
export const InboxReplySchema = z.object({
  id: IdSchema,
  subject: z.string(),
  text: z.string(),
  at: TimestampSchema,
  test: z.boolean(),
  items: z.array(
    z.object({
      itemId: IdSchema,
      number: z.string(),
      documentNumber: z.number().int().min(1),
      /** Ответ по пункту уже есть (внёс контролёр или ответил человек) — «Внести ответ» нет. */
      entered: z.boolean().optional(),
    }),
  ),
});
export type InboxReply = z.infer<typeof InboxReplySchema>;

/** GET /api/inbox/{id}. */
export const InboxCardSchema = z.object({
  notification: NotificationSchema,
  /** Пункт недоступен или протокол не виден — null: карточка показывает только событие (FR-004). */
  item: ControlItemSchema.nullable(),
  /**
   * 0.26.1 (ACC-04): состояние работы пункта — те же слова, что таблица и «Мои задачи»; первое
   * свойство карточки. Цвет контроля (status пункта) — отдельно. Пункт недоступен — нет поля.
   */
  workState: WorkStateSchema.nullable().optional(),
  answer: InboxAnswerSchema.optional(),
  reply: InboxReplySchema.optional(),
  /** «Внести ответ»: право minutes.edit протокола и ответ ещё не внесён. */
  canEnter: z.boolean(),
});
export type InboxCard = z.infer<typeof InboxCardSchema>;
